import React, { useState, useEffect } from "react";
import "./departmentPriceList.css";
import Widgets from "../../widgets";
import plusIcon from "../../Assets/Icons/PlusIcon.png";
import PriceList from "./priceList";
import strings from "../../utils/strings";
import { useTranslation } from "react-i18next";

const DepartmentPriceList = ({ setSelectedView, onDepartmentSelect }) => {
  const { t } = useTranslation();
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const breadcrumbs = ["video_Consultation", "departmentPriceList"];
  const paths = ["/department-price", "/department-price"];
  const { departments } = strings;
  const [search, setSearch] = useState(null);

  // useEffect(() => {
  //   setFilteredData(generatedData);
  // }, []);

  const handleSearch = (query) => {
    setSearch(query);
  };

  const handleButtonClick = () => {
    setSelectedView("addDepartmentPrice");
  };

  const handleItemClick = (priceCode) => {
    onDepartmentSelect(priceCode);
  };

  return (
    <div className="dp-child-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="department-heading">{t("departmentPriceList")}</div>
      <div className="department-search-line">
        <Widgets.SearchBox onSearch={handleSearch} placeholder={"searchWithSpeciality"} />
        <Widgets.IconButton iconSrc={plusIcon} buttonText="newDeptPrice" onClick={handleButtonClick} />
      </div>
      <div className="dp-list-box">
        <PriceList currentPage={currentPage} setCurrentPage={setCurrentPage} onItemClick={handleItemClick} handleSearch={search} />
      </div>
    </div>
  );
};

export default DepartmentPriceList;
